import { useState } from 'react'
import { HorizontalMenu } from '@react-admin/ra-navigation'
import { useMediaQuery, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, Box, Typography, Tooltip } from '@mui/material'

import { getRole } from './common/roles'

import MenuIcon from '@mui/icons-material/Menu'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'

import DashboardIcon from '@mui/icons-material/Dashboard'
import PeopleIcon from '@mui/icons-material/People'
import EventIcon from '@mui/icons-material/Event'
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded'
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import ForumIcon from '@mui/icons-material/Forum'
import PersonPinIcon from '@mui/icons-material/PersonPin'
import StoreIcon from '@mui/icons-material/Store'
import BusinessIcon from '@mui/icons-material/Business'
import SchoolIcon from '@mui/icons-material/School'
import FlagIcon from '@mui/icons-material/Flag'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import RoomIcon from '@mui/icons-material/Room'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'

const CustomHorizontalMenu = ({ role, identity }) => {
  const isAdmin = role === getRole('admin')
  const isResponsable = role >= getRole('responsable')
  const isHippocast = role === getRole('hippocast')
  const isGestionSMS = role === getRole('sms')
  const isPubeur = role < getRole('responsable')
  const isMedicalCenter = identity?.center?.center_type_id === process.env.REACT_APP_CENTER_TYPE_SANTE
  const isStaging = process.env.REACT_APP_SUPABASE_URL?.includes('hrfrmccmvoqcsrizaemh')
  const isMobile = useMediaQuery(
    theme => theme.breakpoints.down('md'),
    { noSsr: true }
  )

  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const menuItems = isHippocast ? [
    { label: 'Tableau de bord', to: '/', value: '', display: true }
  ] : isGestionSMS ? [
    {
      label: 'Conversations',
      icon: <ForumIcon />,
      tooltip: 'Conversations',
      to: "/conversations",
      value: "conversations",
      mobileLabel: 'Conversations',
      display: true 
    }
  ] : [
    {
      label: 'Tableau de bord',
      icon: <DashboardIcon />, 
      tooltip: 'Tableau de bord',
      to: "/",
      value: "",
      mobileLabel: 'Tableau de bord',
      display: true 
    },
    {
      label: 'Contacts',
      icon: <PeopleIcon />, 
      tooltip: 'Contacts',
      to: "/leads",
      value: "leads",
      mobileLabel: 'Etudiants',
      display: true 
    },
    {
      label: 'Évènements',
      icon: <EventIcon />,
      tooltip: 'Évènements',
      to: "/events",
      value: "events",
      mobileLabel: 'Evènements',
      display: true 
    },
    {
      label: 'Catégories d\'évènement',
      icon: <CategoryRoundedIcon />,
      tooltip: 'Catégories d\'évènement',
      to: "/types",
      value: "types",
      mobileLabel: 'Cat. d\'évènements',
      display: isResponsable 
    },
    {
      label: 'Contacts entrants',
      icon: <BrowserUpdatedIcon />,
      tooltip: 'Contacts entrants',
      to: "/inbound_contacts",
      value: "inbound_contacts",
      mobileLabel: 'Contacts entrants',
      display: role >= getRole('coordinateur')
    },
    {
      label: 'Tâches',
      icon: <AssignmentTurnedInIcon />,
      tooltip: 'Tâches',
      to: "/tasks",
      value: "tasks",
      mobileLabel: 'Tâches',
      display: isResponsable
    },
    {
      label: 'Tags',
      icon: <BookmarkIcon />,
      tooltip: 'Tags',
      to: "/tags",
      value: "tags",
      mobileLabel: 'Tags',
      display: isResponsable
    },
    {
      label: 'Conversations',
      icon: <ForumIcon />,
      tooltip: 'Conversations',
      to: "/conversations",
      value: "conversations",
      mobileLabel: 'Conversations',
      display: isResponsable 
    },
    {
      label: 'Profils',
      icon: <PersonPinIcon />, 
      tooltip: 'Profils',
      to: "/profiles",
      value: "profiles",
      mobileLabel: 'Profils',
      display: isResponsable 
    },
    {
      label: 'Centres',
      icon: <StoreIcon />, 
      tooltip: 'Centres',
      to: "/centers",
      value: "centers",
      mobileLabel: 'Centres',
      display: isAdmin 
    },
    {
      label: 'Lycées',
      icon: <BusinessIcon />, 
      tooltip: 'Lycées',
      to: "/schools",
      value: "schools",
      mobileLabel: 'Lycées',
      display: true
    },
    {
      label: 'Rendez-vous',
      icon: <EventAvailableIcon />, 
      tooltip: 'Rendez-vous',
      to: "/rendezvous",
      value: "rendezvous",
      mobileLabel: 'Rendez-vous',
      display: true
    },
    {
      label: 'Facultés',
      icon: <RoomIcon />,
      tooltip: 'Facultés',
      to: "/facultes",
      value: "facultes",
      mobileLabel: 'Facultés',
      display: isResponsable
    },
    {
      label: 'Années scolaires',
      icon: <SchoolIcon />, 
      tooltip: 'Années scolaires',
      to: "/lead_years",
      value: "lead_years",
      mobileLabel: 'Années scolaires',
      display: isAdmin
    },
    {
      label: 'Origines',
      icon: <FlagIcon />, 
      tooltip: 'Origines',
      to: "/lead_sources",
      value: "lead_sources",
      mobileLabel: 'Origines',
      display: isAdmin 
    },
    {
      label: 'Statuts d\'inscription',
      icon: <PlaylistAddCheckIcon />, 
      tooltip: 'Statuts d\'inscription',
      to: "/status_inscription",
      value: "status_inscription",
      mobileLabel: 'Statuts d\'inscription',
      display: isAdmin 
    },
    {
      label: 'Parcoursup',
      icon: <AccountBalanceIcon />,
      tooltip: 'Parcoursup',
      to: '/parcoursup',
      value: 'parcoursup',
      mobileLabel: 'Parcoursup',
      display: isMedicalCenter && isStaging
    },
    {
      label: 'Suivi des imports',
      icon: <MonitorHeartIcon />,
      tooltip: 'Suivi des imports',
      to: '/conversation_import_health',
      value: 'conversation_import_health',
      mobileLabel: 'Suivi des imports',
      display: isAdmin && isStaging
    },
  ]

  const filteredMenuItems = menuItems.filter(item => item.display)

  return isMobile ? (
    <>
      <Box sx={{ position: 'absolute',left: 20, top: 5 }}>
        <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerToggle}>
          <MenuIcon />
        </IconButton>
      </Box>

      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
      >
        <Box sx={{ width: 300 }} onClick={handleDrawerToggle}>
          <Typography variant="h6" sx={{ padding: '20px',display: 'flex',alignItems: 'center',justifyContent: 'space-between' }}>
            <span>Menu</span>
            <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleDrawerToggle}>
              <MenuOpenIcon />
            </IconButton>
          </Typography>
          
          <List>
            {filteredMenuItems.map((item, index) => (
              <ListItem key={index} component="a" href={item.to}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText sx={{ color: '#111' }} primary={item.mobileLabel || item.label} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  ) : (
    <HorizontalMenu sx={{
      '& .MuiSvgIcon-root': { fontSize: '1.3rem' },
      // Preserve original styling from Layout.js
      '& .MuiTab-root': {
        minWidth: isAdmin ? '50px' : isResponsable ? '55px' : '70px',
        fontSize: isAdmin || isResponsable ? '.6rem' : '.8rem',
        fontWeight: isAdmin || isResponsable ? 300 : 500,
        padding: isAdmin || isResponsable ? '0px 5px' : '0px 15px',
        minHeight: '48px',// Fixed height for consistency
        height: '48px',
        // Hide text labels for non-pubeur users  
        ...(!isPubeur && {
          '& .MuiTab-labelContainer': {
            display: 'none'
          }
        }),
        color: '#dfe8e3',
      },
      '& .Mui-selected': {
        color: 'primary.dark'
      }
    }}>
      {filteredMenuItems.map((item, index) => (
        <HorizontalMenu.Item
          key={index}
          label={isPubeur ? item.label : ' '}
          to={item.to}
          value={item.value}
          TabProps={
            isPubeur 
              ? {} 
              : { 
                  icon: (
                    <Tooltip title={item.tooltip} sx={{ mt: 1 }}>
                      {item.icon}
                    </Tooltip>
                  )
                }
          }
        />
      ))}
    </HorizontalMenu>
  )
}

export default CustomHorizontalMenu